import axiosInstance from "@/lib/axiosInterceptor";
import { UseMutationOptions } from "@tanstack/react-query";
import { Result } from "types/result";
import { UsageDetail } from "../types/UsageDetail";

const consumeQuota = async (): Promise<Result<UsageDetail>> => {
    try {
        const { data } = await axiosInstance.post<UsageDetail>(`${process.env.NEXT_PUBLIC_BE_URL}/daily-quota/consume`);
        return { data, error: null };
    } catch (e: any) {
        return { data: null, error: { message: e.message } };
    }
};

export const consumeQuotaOptions = (): UseMutationOptions => {
    return {
        mutationFn: consumeQuota,
        retry: 5,
    };
};
